import { useState } from 'react';

export default function InvoiceImageViewer({ src, alt = "Invoice scan" }) {
  const [isZoomed, setIsZoomed] = useState(false);

  if (!src) {
    return (
      <div className="border border-border rounded-lg p-8 text-center">
        <p className="text-muted-foreground">No image available</p>
      </div>
    );
  }

  return (
    <>
      <div className="overflow-hidden cursor-pointer">
        <img
          src={src}
          alt={alt}
          className="w-full h-auto max-h-full object-contain hover:opacity-90 transition-opacity"
          onClick={() => setIsZoomed(true)}
        />
      </div>

      <p className="text-xs text-muted-foreground mt-2 text-center">
        Click image to view full size
      </p>

      {/* Full-size modal */}
      {isZoomed && (
        <div
          className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4"
          onClick={() => setIsZoomed(false)}
        >
          <div className="relative max-w-full max-h-full">
            <img
              src={src}
              alt={alt}
              className="max-w-full max-h-full object-contain"
              onClick={(e) => e.stopPropagation()}
            />
            <button
              onClick={() => setIsZoomed(false)}
              className="absolute top-4 right-4 bg-white bg-opacity-80 hover:bg-opacity-100 rounded-full p-2 text-black"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
      )}
    </>
  );
}
